module.exports = new __parcel__URL__("deployment-details-popup.tpl.d0e045e6.svg").toString();